import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {ContentBox} from "../../../Common/component/MainScaffold";

export const ExamCurriculumDialogSidebar =({onClickContinue})=>{
    const [t] = useTranslation("global");

    const LectureTypes = Object.freeze({
        MID: "MID", QUIZ: "QUIZ",
    });

    const [selectedType, setSelectedType] = useState(null);
    const maxWidth = "max-w-[700px]";
    return (
        <div className={`flex flex-col h-full justify-between`}>
            <div>
                <div className={`flex flex-col gap-4`}>
                    <ContentBox
                        className={`mx-auto ${maxWidth}`}
                        onClick={() => setSelectedType(LectureTypes.MID)}
                        enabled={selectedType === LectureTypes.MID}
                        title={t("mid")}
                        description={t("mid_description")}
                    />
                    <ContentBox
                        className={`mx-auto ${maxWidth}`}
                        onClick={() => setSelectedType(LectureTypes.QUIZ)}
                        enabled={selectedType === LectureTypes.QUIZ}
                        title={t("quiz")}
                        description={t("quiz_description")}
                    />
                </div>
                <p className={`text-onBackgroundCaption mt-4 ${maxWidth} mx-auto`}>{t("exam_description")}</p>
            </div>

            <button
                onClick={() => selectedType !== null ? onClickContinue(selectedType) : null}
                className={`${maxWidth} bg-primary w-full mx-auto text-white h-14 rounded-lg text-[24px] mb-6`}
            >
                {t("next_button")}
            </button>
        </div>
    );
}